var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0ZM10.488 8.366a.625.625 0 0 0-.988.509v6.25a.625.625 0 0 0 .988.509l4.375-3.125a.624.624 0 0 0 0-1.018l-4.375-3.125Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.488 8.366a.625.625 0 0 0-.988.509v6.25a.625.625 0 0 0 .988.508l4.375-3.125a.624.624 0 0 0 0-1.017l-4.375-3.125Z"
  })));
};
export default SvgPlay;